import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import * as pdfMake from "pdfmake/build/pdfmake";
// @ts-ignore
import * as pdfFonts from "src/assets/fonts/print/vfs_fonts";
import { TokenService } from "./token.service";
import { environment } from "src/environments/environment";
import { TemplatesService } from "src/app/maintenance-templates/templates.service";
import { AppConstants } from "src/app/constants/app.constants";
import { ConcessionaireService } from "src/app/maintenance-concessionaire/concessionaire.service";
import { ToastrAlertService } from "./toastrAlert.service";

var htmlToPdfMake = require("src/app/customHtmlToPdfmake/index.js");

@Injectable({
  providedIn: "root",
})
export class ConvertToPDFService {
  styles = {
    strong: "font-weight: bold;",
    i: "font-style: italic;",
    u: "text-decoration: underline;",
    figure: "display: table; page-break-inside: auto;",
    table: "border: 1px solid; border-collapse: collapse;",
    tr: "border: 1px solid; page-break-inside: avoid;",
    td: "border: 1px solid; padding: 3px;vertical-align: middle;",
    p: "margin-top: 0; margin-bottom: 0;",
  };

  imgBase64: string;
  pie = {
    content: "",
    loaded: false,
  };
  cabecera = {
    content: "",
    loaded: false,
  };

  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService,
    private templateService: TemplatesService,
    private concessionaireService: ConcessionaireService,
    private toastrAlertService: ToastrAlertService
  ) {}

  private applyAutoTag(autoTag: string, formattedHTML: string, style: string) {
    return formattedHTML
      .split("<" + autoTag)
      .join("<" + autoTag + " " + style + " ");
  }

  private addStylesAutoTags(
    tag: string,
    formattedHTML: string,
    style: string
  ): string {
    switch (tag) {
      case "figure":
        const autoTagTables = tag + ' class="table" style="';
        const autoTagImages = tag + ' class="image"';
        formattedHTML = this.applyAutoTag(autoTagTables, formattedHTML, style);
        formattedHTML = this.applyAutoTag(
          autoTagImages,
          formattedHTML,
          'style="text-align: center;"'
        );
        break;
      case "tr":
        const autoTagTr = tag + ' class="pdf-pagebreak-before" style="';
        formattedHTML = this.applyAutoTag(autoTagTr, formattedHTML, style);
        break;
      default:
        const autoTag = tag + ' style="';
        formattedHTML = this.applyAutoTag(autoTag, formattedHTML, style);
        break;
    }
    return formattedHTML;
  }
  public applyMissingStyles(html: string) {
    let formattedHTML = html;

    for (const [tag, style] of Object.entries(this.styles)) {
      formattedHTML = this.addStylesAutoTags(tag, formattedHTML, style);
      formattedHTML = formattedHTML
        .split("<" + tag + ">")
        .join("<" + tag + ' style="' + style + '">');
    }

    // Traducimos los nombres de fuentes desconocidas
    // a nombre de fuente conocidas.
    const regexFontFamilyName = /(font-family:)\s*([^";]+)[^"]*/gi;
    formattedHTML = formattedHTML.replace(regexFontFamilyName, (match) => {
      return "font-family: Seatbcn";
    });

    // Traducimos a numérico los tamaños de
    // fuente con equivalencias obtenidas
    // de la librería pdfmake.js (línea 20151)
    const regexFontSizeName =
      /(font-size:){1}(\s)*(xx-small|x-small|small|medium|large|x-large|xx-large){1}(\s)*(;)/gi;
    formattedHTML = formattedHTML.replace(
      regexFontSizeName,
      (match, p1, p2, p3) => {
        if (p3.toLowerCase() == "xx-small") return "font-size: 9;";
        if (p3.toLowerCase() == "x-small") return "font-size: 10;";
        if (p3.toLowerCase() == "small") return "font-size: 13;";
        if (p3.toLowerCase() == "medium") return "font-size: 16;";
        if (p3.toLowerCase() == "large") return "font-size: 18;";
        if (p3.toLowerCase() == "x-large") return "font-size: 24;";
        if (p3.toLowerCase() == "xx-large") return "font-size: 32;";
        return "16";
      }
    );

    //Eliminamos los tamaños de fuente que no sean en px
    const regexFontSize =
      /style="[^"]*font-size:\s*(xx-small|\d+\.?\d*pt)[^"]*"/g;
    formattedHTML = formattedHTML.replace(regexFontSize, "");

    //Limpiamos los que tienen el style vacio
    const regex2 = /style=""/g;

    formattedHTML = formattedHTML.replace(regex2, "");

    return formattedHTML;
  }

  public async previewPDF(
    html: string,
    peId: any,
    cve: string,
    state: "CR" | "FI" | "OTHER",
    reforma: string,
    type: "open" | "download" | "return" = "open",
    revisor: string,
    marca: string,
    img?: any,
    imgMarca?: string
  ) {
    let content;
    if (reforma.includes("RE")) {
      content = await this.getHeaderAndFooter(html);
    } else {
      content = html;
    }

    const editorData = this.applyMissingStyles(content);
    const filename = "Preview: " + peId.replaceAll("/", "_") + ".pdf";

    content = htmlToPdfMake(editorData, {
      tableAutoSize: true,
    });

    let fixedContent = this.fixPdfContent(content);

    pdfMake.fonts = {
      Seatbcn: {
        normal: "SEATBCN-Regular.ttf",
        bold: "SEATBCN-Bold.ttf",
        italics: "SEATBCN-Italic.ttf",
        bolditalics: "SEATBCN-BoldItalic.ttf",
      },
      CourierNew: {
        normal: "Courier New",
        bold: "Courier New Bold",
        italics: "Courier New Italic",
        bolditalics: "Courier New Bold Italic",
      },
    };

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const imgHeight = this.getImgHeight(imgMarca);
    const textFooter = this.getTextFooter(marca);
    img = img ? img : this.imgBase64;

    console.log("La altura para la imagen de la marca [" + imgMarca + "] es [" + imgHeight + "] pixeles.")

    switch (type) {
      case "open":
        pdfMake
          .createPdf(
            this.configDoc(
              filename,
              img,
              imgHeight,
              peId,
              cve,
              fixedContent,
              state,
              revisor,
              textFooter
            )
          )
          .open();
        break;
      case "download":
        pdfMake
          .createPdf(
            this.configDoc(
              filename,
              img,
              imgHeight,
              peId,
              cve,
              fixedContent,
              state,
              revisor,
              textFooter
            )
          )
          .download();
      case "return":
        return pdfMake.createPdf(
          this.configDoc(
            filename,
            img,
            imgHeight,
            peId,
            cve,
            fixedContent,
            state,
            revisor,
            textFooter
          )
        );
      default:
        break;
    }
  }

  private getTextRevisorFirmante(
    state: "CR" | "FI" | "OTHER",
    revisor: string
  ): string {
    const userCode = this.tokenService.getUserName();
    const fullname = this.tokenService.getFullName();
    let text = "";
    let revisorText = revisor ? revisor : userCode;
    switch (state) {
      case "CR":
        text = "\nFirmado por: " + "  (Revisado por: " + revisorText + ")";
        break;
      case "FI":
        text =
          "\nFirmado por: " +
          fullname +
          "  (Revisado por: " +
          revisorText +
          ")";
        break;
      default:
        text = "\nFirmado por:  (Revisado por:  ) ";
        break;
    }

    return text;
  }

  private configDoc(
    filename: string,
    img: string,
    imgHeight: number,
    peId: string,
    cve: string,
    fixedContent: any,
    state: "CR" | "FI" | "OTHER",
    revisor: string,
    textFooter: string
  ): any {
    let textRevisorFirmante = this.getTextRevisorFirmante(state, revisor);
    let urlCompleta = window.location.href;
    let urlObjeto = new URL(urlCompleta);
    let host = urlObjeto.host;
    return {
      pageSize: "A4",
      pageOrientation: "portrait",
      pageMargins: [57, 75, 57, 75],
      info: {
        title: filename,
        author: "John Doe",
        creator: "John Doe",
        producer: "John Doe",
      },
      header: function () {
        return {
          columns: [
            {
              margin: [500, 20, 20, 0],
              image: "data:image/png;base64," + img,
              width: 45,
              height: imgHeight,
            },
          ],
        };
      },
      footer: function (currentPage, pageCount) {
        return [
          {
            canvas: [
              { type: "line", x1: 55, y1: 0, x2: 540, y2: 0, lineWidth: 1 },
            ],
          },
          {
            columns: [
              {
                margin: [55, 10, 0, 0],
                fontSize: 6,
                width: "83%",
                text: [
                  {
                    text:
                      window.location.protocol +
                      "//" +
                      host +
                      "/descargas/cert",
                  },
                  {
                    text: "\nCódigo solicitud: " + peId,
                  },
                  {
                    text: "\nCVE: " + cve,
                  },
                  { text: textRevisorFirmante },
                  { text: "\nPágina " + currentPage + " de " + pageCount },
                  {
                    text: textFooter,
                  },
                ],
              },
              {
                margin: [0, 10, 0, 0],
                qr:
                  environment.env +
                  "/descargas/certificado?codigoCve=" +
                  cve +
                  "&codigoSolicitud=" +
                  peId,
                fit: "45",
              },
            ],
            columnGap: 1,
          },
        ];
      },
      content: fixedContent,
      defaultStyle: {
        font: "Seatbcn",
        fontSize: 7.5,
        lineHeight: 1.2,
      },
    };
  }

  private fixPdfContent(content) {
    // Verificar si el contenido es una tabla y aplicar configuraciones si es necesario
    if (Array.isArray(content)) {
      content.forEach((element) => {
        if (element.table) {
          // Ajustar configuraciones de la tabla, por ejemplo, layout: 'noBorders'
          element.table.layout = "noBorders";
        }
        if (element.pageBreakAfter && element.pageBreakAfter === "always") {
          element.pageBreak = "after";
        }
      });
    }

    return content;
  }

  public getImg(marca: string): Promise<any> {
    const ruta = "assets/images/logos/" + this.getrutaImg(marca);

    return new Promise<any>((resolve, reject) => {
      this.httpClient.get(ruta, { responseType: "arraybuffer" }).subscribe(
        (data) => {
          const binaryString = String.fromCharCode.apply(
            null,
            new Uint8Array(data as ArrayBuffer)
          );
          this.imgBase64 = btoa(binaryString);
          resolve(this.imgBase64);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  private getImgHeight(marca: string): number {
    const defaultImgHeight = 45;
    if(marca == null) return defaultImgHeight;

    switch (marca) {
      case "VW":
        return 45;

      case "SE":
        return 40;

      case "AU":
        return 15;

      case "SK":
        return 31;

      case "CU":
        return 35;

      default:
        return defaultImgHeight;
    }
  }

  private getTextFooter(marca: string): string {
    switch (marca) {
      case "VW":
        return AppConstants.footerPDF.VW;

      case "SE":
        return AppConstants.footerPDF.SE;

      case "AU":
        return AppConstants.footerPDF.AU;

      case "SK":
        return AppConstants.footerPDF.SK;

      case "CU":
        return AppConstants.footerPDF.SE;

      case "CANARIAS":
        return AppConstants.footerPDF.CANARIAS;

      default:
        return AppConstants.footerPDF.SK;
    }
  }

  private getrutaImg(marca: string) {
    switch (marca) {
      case "VW":
        return "VWLogo.png";

      case "SE":
        return "SeatLogo.png";

      case "AU":
        return "AudiLogo.png";

      case "SK":
        return "SkodaLogo.png";

      case "CU":
        return "CupraLogo.png";

      default:
        return "Logotriton.png";
    }
  }

  private async getHeaderAndFooter(html: string) {
    let cabecera;
    let pie;
    if (!this.cabecera.loaded) {
      cabecera = await this.templateService.getTemplateSync("CABECERA_REFORMA");
      cabecera = new TextDecoder().decode(
        new Uint8Array(
          [...atob(cabecera[0][3]?.piTexto)].map((char) => char.charCodeAt(0))
        )
      );
      this.cabecera.loaded = true;
      this.cabecera.content = cabecera;
    } else {
      cabecera = this.cabecera.content;
    }
    if (!this.pie.loaded) {
      pie = await this.templateService.getTemplateSync("PIE_REFORMA");

      pie = new TextDecoder().decode(
        new Uint8Array(
          [...atob(pie[0][3]?.piTexto)].map((char) => char.charCodeAt(0))
        )
      );
      this.pie.loaded = true;
      this.pie.content = pie;
    } else {
      pie = this.pie.content;
    }

    return cabecera + html + pie;
  }

  public setLoadedFooterAndHeader() {
    this.cabecera.loaded = true;
    this.pie.loaded = true;
  }

  public getRegionByConcesionaire(peCpeticionario: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.concessionaireService
        .getRegionByConcessionaire(peCpeticionario)
        .subscribe(
          (data) => {
            resolve(data.region);
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
            reject(err);
          }
        );
    });
  }
}
